import { HashRouter, Route, Switch } from "react-router-dom"
import { Message } from "semantic-ui-react"

import HomePage from "../components/HomePage"
import { FormPrioritario } from "../pages"
import Dashboard from "../pages/Dashboard"
import Login from "../pages/login"
import { PageFormRelato } from "../pages/PageFormRelato"
import { PagePautas } from "../pages/PagePautas"
import { PageResumo } from "../pages/PageResumo"
import PageUsers from "../pages/auth/PageUsers"
import Viewer from "../pages/viewer"
import { useStore } from "../stores/useStoreProfile"
import PageUserEdit from "../pages/auth/PageUserEdit"
import PageUserGroupOrPermission from "../pages/auth/PageUserGroupOrPermission"
import PageAdmin from "../pages/PageAdmin"

export function Routes() {
  const { token } = useStore()

  return token
    ? <HashRouter>
      <HomePage>
        <Switch>
          <Route component={Dashboard} exact path="/" />
          <Route component={Viewer} path="/prioritario/visualizar/:id" />
          <Route
            component={FormPrioritario}
            path={["/prioritario/novo", "/prioritario/editar/:id"]}
          />
          <Route
            component={PagePautas}
            path={["/destaque/nova", "/destaque/editar/:id", '/destaque/visualizar/:id']}
          />
          <Route component={PageFormRelato} path={"/prioritario/relatar/:id"} />
          <Route component={PageResumo} path={"/prioritario/resumir/:id"} />
          <Route component={PageUserGroupOrPermission} path={'/auth/users/:userId/groups/:groupId'} />
          <Route component={PageUserGroupOrPermission} path={'/auth/users/:userId/permissions/:permissionId'} />
          <Route component={PageUserEdit} path={'/auth/users/:id'} />
          <Route component={PageUsers} path={'/auth/users/'} />
          <Route component={PageAdmin} path={'/admin/'} />
          <Route>
            <Message
              icon="warning sign"
              warning
              header="Página não encontrada"
            />
          </Route>
        </Switch>
      </HomePage>
    </HashRouter>
    : <Login />
}
